import * as React from 'react';
import { Typography } from '@mui/material';
var WordsStat = function (_a) {
    var learnedWords = _a.learnedWords, averageAnswers = _a.averageAnswers;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                padding: 20,
                display: 'flex',
                flexWrap: 'wrap',
                gap: 20,
            } },
            React.createElement("div", null,
                React.createElement(Typography, { variant: "h4", component: "h4", sx: { fontWeight: 'bold' } }, learnedWords)),
            React.createElement("div", null,
                React.createElement(Typography, { variant: "h5", component: "h5", sx: { fontWeight: 'bold' } }, "c\u043B\u043E\u0432"),
                React.createElement(Typography, { variant: "h5", component: "h5" }, "\u0438\u0437\u0443\u0447\u0435\u043D\u043E")),
            React.createElement("div", null),
            React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', gap: 20 } },
                React.createElement("div", null,
                    React.createElement(Typography, { variant: "h4", component: "h4", sx: { fontWeight: 'bold' } }, averageAnswers)),
                React.createElement("div", null,
                    React.createElement(Typography, { variant: "h5", component: "h5", sx: { fontWeight: 'bold' } }, "\u043D\u043E\u0432\u044B\u0445 \u0441\u043B\u043E\u0432"),
                    React.createElement(Typography, { variant: "h5", component: "h5" }, "\u0437\u0430 \u0434\u0435\u043D\u044C"))))));
};
export default WordsStat;
